module.exports = __webpack_public_path__ + "resources/img/img_cloud_architecture_04.1a56728e864882021636d093d60f7ac7.png";